var _path, _path2, _circle, _line, _line2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorWorkplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.747,22.783H5.253V6.797c0-1.263,1.033-2.297,2.296-2.297h26.901c1.263,0,2.297,1.033,2.297,2.297v15.986Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.253,22.783v3.212c0,1.263,1.033,2.296,2.296,2.296h26.672c1.389,0,2.526-1.137,2.526-2.526v-2.983H5.253Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.137,
    cy: 25.42,
    r: 0.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.312,
    y1: 33.556,
    x2: 18.633,
    y2: 33.556
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.897,
    y1: 33.556,
    x2: 28.218,
    y2: 33.556
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.633,
    y: 28.292,
    width: 5.264,
    height: 5.264
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3.036,37.499l1.921-2.263c.905-1.066,2.233-1.681,3.632-1.681h24.822c1.399,0,2.727.615,3.632,1.681l1.921,2.263"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorWorkplace);
export default __webpack_public_path__ + "static/media/indoor-workplace.d29a95810a6ad731ddd74f1ae10e2c86.svg";
export { ForwardRef as ReactComponent };